import { AvatarDropdown, AvatarName, NoticeIcon, LanguageSwitch } from '@/components';
import {
  DashboardOutlined,
  FileTextOutlined,
  ProfileOutlined,
  ProjectOutlined,
  RollbackOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import { ProLayout } from '@ant-design/pro-components';
import { useLocation, Outlet, useNavigate } from 'react-router';
import { Button } from 'antd';
import { Suspense, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useAuth from '@/hooks/useAuth';
import ContentLoading from '@/components/ContentLoading';

const Aspice: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [pathname, setPathname] = useState(location.pathname);
  const navigate = useNavigate();
  const { clearAuthData } = useAuth();

  useEffect(() => {
    const handleMenuUpdate = (event: CustomEvent) => {
      setPathname(event.detail.pathname);
    };

    window.addEventListener('update-menu', handleMenuUpdate as EventListener);
    return () => {
      window.removeEventListener('update-menu', handleMenuUpdate as EventListener);
    };
  }, []);

  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === 'access_token' && !event.newValue) {
        clearAuthData();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const handleBackToProject = () => {
    navigate('/overview');
  };

  return (
    <ProLayout
      title={t('appTitle')}
      logo="/logo.png"
      layout="mix"
      siderWidth={256}
      fixSiderbar
      fixedHeader
      route={{
        path: '/aspice',
        routes: [
          {
            path: '/aspice/overview',
            name: t('menu.aspice.overview'),
            icon: <DashboardOutlined />,
          },
          {
            path: '/aspice/projects',
            name: t('menu.aspice.projects'),
            icon: <ProjectOutlined />,
          },
          {
            path: '/aspice/templates',
            name: t('menu.aspice.templates'),
            icon: <FileTextOutlined />,
          },
          {
            path: '/aspice/roles',
            name: t('menu.aspice.roles'),
            icon: <TeamOutlined />,
          },
          {
            path: '/aspice/processdocs',
            name: t('menu.aspice.processdocs'),
            icon: <ProfileOutlined />,
          },
        ],
      }}
      location={{
        pathname,
      }}
      actionsRender={() => [
        <Button key="back" type="link" icon={<RollbackOutlined />} onClick={handleBackToProject}>
          {t('menu.aspice.backToNormal')}
        </Button>,
        <LanguageSwitch key="language" />,
        <NoticeIcon key="notice" />,
      ]}
      avatarProps={{
        title: <AvatarName />,
        render: (_, avatarChildren) => {
          return <AvatarDropdown>{avatarChildren}</AvatarDropdown>;
        },
      }}
      menuItemRender={(item, dom) => (
        <div
          onClick={() => {
            navigate(item.path || '/aspice/overview');
            setPathname(item.path || '/aspice/overview');
          }}
        >
          {dom}
        </div>
      )}
      token={{
        header: {
          heightLayoutHeader: 48,
        },
      }}
    >
      <Suspense fallback={<ContentLoading />}>
        <Outlet />
      </Suspense>
    </ProLayout>
  );
};

export default Aspice;
